import { render, staticRenderFns } from "./FileUploadQuestion.vue?vue&type=template&id=b566f7f6&scoped=true"
import script from "./FileUploadQuestion.vue?vue&type=script&lang=js"
export * from "./FileUploadQuestion.vue?vue&type=script&lang=js"
import style0 from "./FileUploadQuestion.vue?vue&type=style&index=0&id=b566f7f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b566f7f6",
  null
  
)

export default component.exports